import type { Locality } from '../type/locality';

const formatLocality = (locality: Locality) => {
    return `${locality.Title}, ${
        locality.Region ? locality.Region.Title + ', ' : ''
    }${locality.Postcode}`;
};

export default formatLocality;
